"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var Login_1 = require("./Login");
var Register_1 = require("./Register");
var Auth_1 = require("../stores/Auth");
var General_1 = require("../services/General");
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLoginModalOpen = function () {
            _this.setState({ loginModelOpen: true });
        };
        _this.handleRegisterModalOpen = function () {
            _this.setState({ registerModalOpen: true });
        };
        _this.handleLoginModalClose = function () {
            _this.setState({ loginModelOpen: false });
        };
        _this.handleRegisterModalClose = function () {
            _this.setState({ registerModalOpen: false });
        };
        _this.handleDismissForIEBanner = function () {
            _this.setState({ isIEBannerVisible: false });
        };
        _this.state = {
            loginModelOpen: false,
            registerModalOpen: false,
            isIEBannerVisible: true,
            authUser: Auth_1.default.getUser()
        };
        return _this;
    }
    Home.prototype.render = function () {
        var subHeader = this.state.authUser ? "User email: " + this.state.authUser.email : 'Choose one of the options below.';
        return (React.createElement(semantic_ui_react_1.Container, null,
            ((General_1.isIE() === true) && (this.state.isIEBannerVisible)) && (React.createElement(semantic_ui_react_1.Message, { icon: 'bullhorn', header: 'An Important Message from NJCRIB', content: React.createElement("span", null,
                    "We notice your using Internet Explorer to view this page. For the best viewing experience, please consider using another browser. More information is available ",
                    React.createElement("a", { href: "https://www.njcrib.com/additionalinfo/supportedbrowsers" }, "here"),
                    "."), onDismiss: this.handleDismissForIEBanner, warning: true })),
            React.createElement(semantic_ui_react_1.Header, { as: 'h1', content: 'Welcome to NJ Online CCPAP', inverted: true, style: { fontSize: '4em', fontWeight: 'normal', marginBottom: 0 } }),
            React.createElement(semantic_ui_react_1.Header, { as: 'h2', content: subHeader, inverted: true, style: { fontSize: '1.7em', fontWeight: 'normal', marginTop: '1em' } }),
            React.createElement("ul", { style: { margin: '0', padding: '0' } },
                React.createElement("li", { style: { display: 'inline-block', width: '33%', padding: '0em 0.6em' } },
                    React.createElement(semantic_ui_react_1.Card, { fluid: true, color: 'green', onClick: this.handleRegisterModalOpen, style: { height: '220px' } },
                        React.createElement(semantic_ui_react_1.Card.Content, { textAlign: "center" },
                            React.createElement(semantic_ui_react_1.Icon, { color: 'green', name: "user plus", size: "huge", style: { margin: '0.6em 0em' } }),
                            React.createElement(semantic_ui_react_1.Card.Header, null, "Register"),
                            React.createElement(semantic_ui_react_1.Card.Description, null, "Click here to register.")))),
                React.createElement("li", { style: { display: 'inline-block', width: '33%', padding: '0em 0.6em' } },
                    React.createElement(semantic_ui_react_1.Card, { fluid: true, color: 'green', onClick: this.handleLoginModalOpen, style: { height: '220px' } },
                        React.createElement(semantic_ui_react_1.Card.Content, { textAlign: "center" },
                            React.createElement(semantic_ui_react_1.Icon, { color: 'green', name: "user circle", size: "huge", style: { margin: '0.6em 0em' } }),
                            React.createElement(semantic_ui_react_1.Card.Header, null, "Login"),
                            React.createElement(semantic_ui_react_1.Card.Description, null, "Click here to log in and view saved applications.")))),
                React.createElement("li", { style: { display: 'inline-block', width: '33%', padding: '0em 0.6em' } },
                    React.createElement(semantic_ui_react_1.Card, { fluid: true, color: 'green', as: react_router_dom_1.Link, to: '/application', style: { height: '220px' } },
                        React.createElement(semantic_ui_react_1.Card.Content, { textAlign: "center" },
                            React.createElement(semantic_ui_react_1.Icon, { color: 'green', name: "plus circle", size: "huge", style: { margin: '0.6em 0em' } }),
                            React.createElement(semantic_ui_react_1.Card.Header, null, "New Application"),
                            React.createElement(semantic_ui_react_1.Card.Description, null, "Click here to start a new CCPAP application."))))),
            React.createElement(Login_1.default, { modalOpen: this.state.loginModelOpen, handleClose: this.handleLoginModalClose }),
            React.createElement(Register_1.default, { modalOpen: this.state.registerModalOpen, handleClose: this.handleRegisterModalClose })));
    };
    return Home;
}(React.Component));
exports.default = Home;
//# sourceMappingURL=Home.js.map